import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";

export default function RequireAuth({ children, requireOrg = true, roles }) {
  const { user, loading, currentOrg, role } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        data-testid="auth-loading"
        className="min-h-screen flex items-center justify-center bg-canvas text-zinc-500"
      >
        Загрузка…
      </div>
    );
  }

  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  if (requireOrg && !currentOrg) {
    return <Navigate to="/no-orgs" replace />;
  }

  if (roles && roles.length > 0 && !roles.includes(role)) {
    return (
      <div
        data-testid="forbidden-role"
        className="min-h-[60vh] flex items-center justify-center text-zinc-500"
      >
        У вас недостаточно прав для просмотра этой страницы.
      </div>
    );
  }

  return children || <Outlet />;
}
